import {
  Box,
  Button,
  Container,
  Dialog,
  Grid,
  Skeleton,
  Stack,
} from "@mui/material";
import {
  STRINGS_CATEGORIES,
  STRINGS_CREATE,
} from "../../../../data/strings/Strings";
import {
  COLOR_BLACK,
  COLOR_LESS_BLACK,
  COLOR_LIGHT_GRAY,
} from "../../../../data/colors/Colors";
import { AddRounded, SortRounded } from "@mui/icons-material";
import { CategoriesViewModel } from "./CategoriesViewModel";
import { CategoriesListItemView } from "./categoriesListItemView/CategoriesListItemView";
import {
  ROUTE_ENDPOINTS,
  ROUTE_NEW,
} from "../../../../data/constant/RouteConstants";
import { CustomTextView } from "../../../component/CustomTextView";
import { HeaderView } from "../../../component/HeaderView";
import { provideGetAllCategoriesUseCase } from "../../../di/UseCasesModule";
import { EmptyView } from "../../../component/EmptyView";
import useWindowDimensions from "../../../../core/utils/UseWindowDimensions";
import { showGlobalLoadingView } from "../../../../core/utils/Utils";
import { CustomCardView } from "../../../component/CustomCardView";

const CategoriesListItemSkeletonView = () => {
  return (
    <CustomCardView
      padding={0}
      borderRadius={6}
      children={
        <Stack spacing={0} width={"100%"} height={280} position={"relative"}>
          <Skeleton variant="rectangular" width="100%" height="100%" />
          <Stack position={"absolute"} bottom={0} zIndex={2} width={"100%"}>
            <Stack p={1} width={"100%"}>
              <Skeleton
                variant="rounded"
                width="100%"
                height={40}
                sx={{ borderRadius: 12 }}
              />
            </Stack>
          </Stack>
        </Stack>
      }
    />
  );
};

export function CategoriesView() {
  const viewModel = CategoriesViewModel(provideGetAllCategoriesUseCase());
  const { width } = useWindowDimensions();
  const isMobile = width < 900;
  return (
    <Box>
      <Stack spacing={2}>
        <HeaderView
          title={STRINGS_CATEGORIES}
          layout={
            <Stack
              direction={"row"}
              spacing={1}
              width={"100%"}
              justifyContent={"end"}
              display={"flex"}
            >
              <Button
                href={`${ROUTE_ENDPOINTS.HOME_CATEGORIES}/${ROUTE_NEW}`}
                LinkComponent={"a"}
                variant="outlined"
                sx={{
                  borderRadius: 22,
                  borderColor: COLOR_LESS_BLACK,
                  "&:hover": {
                    borderColor: COLOR_LESS_BLACK,
                  },
                }}
                fullWidth={isMobile}
              >
                <AddRounded
                  fontSize="medium"
                  sx={{ color: COLOR_LESS_BLACK }}
                />
                <Box width={10} />
                <CustomTextView
                  text={STRINGS_CREATE}
                  fontWeight="bold"
                  fontSize={16}
                  props={{ textTransform: "none" }}
                />
              </Button>
            </Stack>
          }
        />
        <Container maxWidth={false}>
          <>
            {viewModel.isLoading ? (
              <Grid container spacing={1.5} pt={1} pb={3}>
                {Array.from(new Array(12)).map((_, index) => (
                  <Grid
                    size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 3 }}
                    key={index}
                  >
                    <CategoriesListItemSkeletonView />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <>
                {viewModel.categories && (
                  <>
                    {viewModel.categories.length === 0 ? (
                      <EmptyView />
                    ) : (
                      <Grid container spacing={1.5} pt={1} pb={3}>
                        {viewModel.categories.map((category, index) => {
                          return (
                            <Grid
                              size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 3 }}
                              key={category._id}
                            >
                              <CategoriesListItemView
                                category={category}
                                index={index}
                                href={`${ROUTE_ENDPOINTS.HOME_CATEGORIES}/${category._id}`}
                              />
                            </Grid>
                          );
                        })}
                      </Grid>
                    )}
                  </>
                )}
              </>
            )}
          </>
        </Container>
      </Stack>
    </Box>
  );
}
